import { setDetailParams, setSelectedClient } from "../../state/clientMasterSlice"
import {
  faPlus,
  faUser,
  faPenToSquare,
  faGlobe,
  faTrash,
} from "@fortawesome/free-solid-svg-icons"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useFetchWithBody, useGet, usePost } from "../../api/reactQueryCustomHooks"
import { AutoCompleteInput, ConfirmBox, ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { ROW_ACTION_BTN_TYPE } from "../../components/NextUITable"
import { setIsNewEntry } from "../../state/userMasterSlice"
import { Autocomplete, AutocompleteItem, Button, Checkbox, Drawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader, form, Input, useDisclosure } from "@nextui-org/react"
import { useEffect, useMemo, useState } from "react"
import { toast } from "react-toastify"

function ClientMaster() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [itemToDelete, setItemToDelete] = useState("")
  const [selFilterType, setSelFilterType] = useState("")
  const [clientData, setClientData] = useState([])
  const [formData, setFormData] = useState({
    clientId: 0,
    clientType: "",
    clientCode: "",
    clientName: "",
    clientGroup: "",
    isActive: true
  })
  const [isNewEntry, setIsNewEntry] = useState(true)
  const exportColumns = [
    { uid: "Client_Code", name: "CLIENT CODE" },
    { uid: "Client_Name", name: "CLIENT NAME" },
    { uid: "Client_Group", name: "CLIENT GROUP" },
  ]

  const {
    data: clientTypeMast = [],
    mutate: funGetClientType
  } = usePost({
    url: apiRoute.clientMaster.getClientType,
    queryKey: "ClientTypeMaster",
  })

  console.log(clientTypeMast, "sd")

  const {
    isPending,
    isError,
    cdata = [],
    mutate: filterData
  } = usePost({
    url: apiRoute.clientMaster.getEntryData,
    queryKey: "ClientMaster",
    onSuccessTasks: (data) => {
      setClientData(data)
    }
  })

  const data = useMemo(() => {
    if (clientData && clientData.length > 0) {
      if (selFilterType && selFilterType != null && selFilterType != "") {
        return clientData.filter((item) => item.ClientType == selFilterType)
      }
    }
    return clientData
  }, [clientData, selFilterType])
  const funLoadData = () => {
    filterData({
      data: {

      }
    })
  }
  useEffect(() => {
    funLoadData();
    funGetClientType({
      data: {}
    })
  }, [])

  const {
    mutate: funDelete
  } = usePost({
    url: apiRoute.clientMaster.deleteEntry,
    queryKey: "DeleetClientMaster",
    onSuccessTasks: (data) => {
      setItemToDelete("")
      if (data && data.length > 0) {
        if (data[0].ref == 1)
          toast.error("Client can't be delete as it lock", {
            position: "top-center"
          })
        else {
          toast.success("Client deleted", {
            position: "top-center"
          })
          funLoadData();

        }
      }

    }
  })

  const {
    isPending: ispendingSubmit,
    isError: isErrorSubmit,
    mutate: funAddUpdate
  } = usePost({
    url: apiRoute.clientMaster.addUpdate,
    queryKey: "ClientMaster",
    onSuccessTasks: (data) => {
      toast.success(`Entry ${isNewEntry ? "Inserted" : "Updated"} `, {
        position: "top-center"
      })
      setIsNewEntry(true)
      setFormData({
        clientId: 0,
        clientCode: "",
        clientType: "",
        clientName: "",
        clientGroup: "",
        isActive: true
      })
      funLoadData();
      funGetClientType({
        data: {}
      })
      //onClose();

    }
  })
  const funSubmit = () => {

    funAddUpdate({
      data: {
        clientId: formData.clientId,
        clientCode: formData.clientCode,
        clientName: formData.clientName,
        clientType: formData.clientType,
        clientGroup: formData.clientGroup,
        isActive: formData.isActive == true ? 1 : 0,
        recStatus: isNewEntry ? 2 : 1
      }
    })
  }

  const {
    mutate: funChkCode
  } = usePost({
    url: apiRoute.clientMaster.checkClientCode,
    queryKey: "ClientMaster",
    onSuccessTasks: (data) => {
      if (data && data.length > 0) {
        toast.error("Client Code Exists Use Another One", {
          position: "top-center"
        })
        return;
      }
      else {
        funSubmit();
      }

    }
  })

  const columns = [
    {
      name: "ACTIONS",
      uid: "actions",
    },
    { uid: "Client_Code", name: "CLIENT CODE" },
    { uid: "Client_Name", name: "CLIENT NAME" },
    { uid: "ClientType", name: "Type" },
    { uid: "Client_Group", name: "CLIENT GROUP" },
  ]

  const INITIAL_VISIBLE_COLUMNS = [
    "actions",
    "Client_Code",
    "Client_Name",
    "ClientType",
    "Client_Group"
  ]

  const topActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPlus} />,
      onClick: () => {
        onOpen()
        setIsNewEntry(true)
        setFormData({
          clientId: 0,
          clientCode: "",
          clientType: "",
          clientName: "",
          clientGroup: "",
          isActive: true
        })
        //navigate(linksUrl.client.createEntry)
      },
      label: "Add Client",
    },
  ]

  const handleChange = (e) => {
    const { value, name } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon icon={faPenToSquare} className="text-lime-600 text-md p-3 bg-lime-50" />,
      onClick: (row) => {
        setIsNewEntry(false)
        console.log(row)
        setFormData({
          ...formData,
          clientId: row?.Id,
          clientCode: row?.Client_Code,
          clientName: row?.Client_Name,
          clientGroup: row?.Client_Group,
          clientType: row?.ClientType,
          isActive: row?.IsActive == 1 ? true : false
        })
        onOpen();
      },
      label: "",
      type: ROW_ACTION_BTN_TYPE.link,
    },


    {
      icon: <FontAwesomeIcon icon={faTrash} className="text-red-600 text-md p-3 bg-red-50" />,
      onClick: (row) => {
        setItemToDelete(row)
      },
      label: "",
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ]
  const handleConfirmBox = (data) => {
    if (data) {
      if (itemToDelete && itemToDelete != null) {
        funDelete({
          data: {
            client_code: itemToDelete?.Client_Code,
          }
        })
      }
    }
    else {
      setItemToDelete("")
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(isNewEntry)
    if (isNewEntry) {
      funChkCode({
        data: {
          client_code: formData.clientCode
        }
      })
    }
    else {
      funSubmit();
    }
  }


  if (ispendingSubmit, isPending) {
    return <LoadingCard />
  }

  if (isError, isErrorSubmit) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Client Master">

        <Drawer isOpen={isOpen} onOpenChange={onOpenChange}>
          <DrawerContent>
            {(onClose) => (
              <>
                <DrawerHeader className="flex flex-col gap-1">Drawer Title</DrawerHeader>
                <DrawerBody>
                  <form onSubmit={handleSubmit}>
                    <div className="p-1  font-semibold text-rose-700 bg-red-50 uppercase  ">{` ${isNewEntry ? "New Client Entry" : "Update Client Entry"}  `}</div>
                    <br />
                    <div className=" w-full flex-wrap md:flex-nowrap   mb-2 gap-4">
                      <Input
                        type="text"
                        label="Client Code"
                        placeholder=" "
                        labelPlacement="outside"
                        isRequired
                        isReadOnly={isNewEntry ? false : true}
                        name="clientCode"
                        variant="bordered"
                        className="font-semibold  pb-3"
                        value={formData.clientCode}
                        onChange={handleChange}

                      //isDisabled={isPending}
                      />

                      <AutoCompleteInput
                        label={"Client Type"}
                        value={formData.clientType}
                        name={"clientType"}
                        options={clientTypeMast || []}
                        optionKey={"ClientType"}
                        optionValue=""
                        labelClass="text-slate-900 text-sm font-bold"
                        cssClass="mb-2"
                        isrequired={true}
                        onChange={(val) =>
                          setFormData(prev => ({ ...prev, "clientType": val, }))
                        }
                        onSelect={(item) => {
                          console.log("Selected:", item);
                        }}
                        onCreate={(newName) => {
                          console.log("Create new:", newName);
                          // call API here if needed
                        }}
                      />
                      <Input
                        type="text"
                        label="Client Name."
                        placeholder=" "
                        className="font-semibold  pb-3"
                        labelPlacement="outside"
                        name="clientName"
                        isRequired
                        variant="bordered"
                        value={formData.clientName}
                        onChange={handleChange}
                      // isDisabled={isPending}
                      />
                      <Input
                        type="text"
                        label="Client Group."
                        className="font-semibold  pb-3"
                        placeholder=" "
                        labelPlacement="outside"
                        name="clientGroup"
                        isRequired
                        variant="bordered"
                        value={formData.clientGroup}
                        onChange={handleChange}
                      // isDisabled={isPending}
                      />

                      <Checkbox size="md"
                        classNames={{ "label": "text-pink-500 text-md font-semibold" }}
                        className="py-1 px-2 mt-2  " color={"danger"} isSelected={formData.isActive}
                        onValueChange={(val) => setFormData({ ...formData, isActive: val })} >Is Active</Checkbox>
                      <div className="my-5 text-center w-full mx-auto flex gap-5 items-center">
                        <Button color="warning" type="submit" size="sm" className="font-semibold" >
                          Submit
                        </Button>
                        <Button color="danger" size="sm" variant="solid" className="font-semibold" onPress={onClose}>
                          Close
                        </Button>
                      </div>
                    </div>
                  </form>
                </DrawerBody>
                {/* <DrawerFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
               
              </DrawerFooter> */}
              </>
            )}
          </DrawerContent>
        </Drawer>
        <div className=" w-full flex-wrap md:flex-nowrap shadow-sm p-2 mb-5  border-1 gap-4">
          <Autocomplete
            size="sm"
            label={"Client Type"}
            eventResizeFeature={true}
            selectionMode="single"
            showScrollIndicators={true}
            labelPlacement={"outside"}
            placeholder={"ALL"}
            //isRequired={true}
            //  isLoading={isLoadingClient}
            //isReadOnly={isNewEntry ? false : true}
            menuTrigger={"input"}
            className="max-w-23 font-semibold"
            classNames={{
              label: "text-xs text-black font-bold",
            }}
            isClearable={true}
            isVirtualized
            defaultItems={
              clientTypeMast || []
            }
            color="warning"
            onSelectionChange={setSelFilterType}
            variant="flat"
            selectedKey={selFilterType}

          >
            {(list) => (
              <AutocompleteItem

                key={list.ClientType}
              >
                {list.ClientType}
              </AutocompleteItem>
            )}
          </Autocomplete>
        </div>
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
          data={data}
          columns={columns}
          exportColumns={exportColumns}
          topActionBtn={topActionBtn}

          rowActionBtn={rowActionBtn}
          downloadFileName="Client_Master"
          id="Client_Code"
        />
      </MainContainer>
      {(itemToDelete) && (
        <ConfirmBox
          handleConfirmBox={handleConfirmBox}
        />
      )}
    </div>
  )
}

export default ClientMaster
